<template>
  <div>
    <v-simple-table class="scheme-tbl">
      <template v-slot:default>
        <thead>
          <tr>
            <th>YEAR</th>
            <th v-for="(mn, mIndex) in months" :key="mIndex">{{ mn }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(yr, tIndex) in Object.keys(tdm)" :key="tIndex">
            <td>{{ yr }}</td>
            <td v-for="(mn, i) in months" :key="i">
              <template v-if="tdm[yr][mn]">
                <v-icon
                  x-small
                  color="success"
                  v-if="tdm[yr][mn].paymentStatus == 0"
                  >mdi-check</v-icon
                >
                <v-icon
                  x-small
                  color="warning"
                  v-if="tdm[yr][mn].paymentStatus == 2"
                  >mdi-checkbox-blank-circle-outline</v-icon
                >
                <v-icon
                  x-small
                  color="error"
                  v-if="tdm[yr][mn].paymentStatus == 1||tdm[yr][mn].paymentStatus == 3"
                  >mdi-close</v-icon
                >
              </template>
              <!-- <v-icon v-else>mdi-</v-icon> -->
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="text-center pt-2 pb-2" style="font-size: x-small;">
    <v-icon left right x-small color="success">mdi-check</v-icon>Paid
    <v-icon left right x-small color="error">mdi-close</v-icon>Pending/Partially Paid
    <v-icon left right x-small color="warning">mdi-checkbox-blank-circle-outline</v-icon>Upcoming
  </div>  
  </div>
</template>
<script>
import dayjs from "dayjs";
import localeData from "dayjs/plugin/localeData";
dayjs.extend(localeData);
export default {
  data: () => ({
    tdm: {},
    months: [],
  }),
  props: {
    // schemeDetail
    sdtl: Object,
  },
  mounted() {
    this.getInital();
    this.months = dayjs()
      .localeData()
      .monthsShort();
  },
  methods: {
    getInital() {
      this.dpLoading = true;
      this.sdtl.transactionDetailModel.forEach((t,tIndex) => {
        t.year = dayjs(t.date).format("YYYY");
        t.month = dayjs(t.date).format("MMM");
        // Object.groupBy not supported in some mobile browsers
        if (!this.tdm[t.year]) {
          this.tdm[t.year] = [];
        }
        this.tdm[t.year].push(t);
        if(tIndex == this.sdtl.transactionDetailModel.length-1){
          this.dpLoading = false;
        }

      });
      // this.tdm = Object.groupBy(
      //   this.sdtl.transactionDetailModel,
      //   (t) => t.year
      // );
      this.dpLoading = true;
      Object.keys(this.tdm).forEach((yr, tIndex) => {
        let tdmYr = this.tdm[yr];
        this.tdm[yr] = {};
        tdmYr.forEach((ty, tyIndex) => {
          this.tdm[yr][ty.month] = ty;
        });
        if(tIndex == Object.keys(this.tdm).length-1){
          this.dpLoading = false;
        }
      });
    },
  },
};
</script>
<style>
.scheme-tbl th,
.scheme-tbl td {
  padding-inline: 3px !important;
  height: 35px !important;
  font-size: x-small !important;
}
</style>
